'use client'
import Link from "next/link";
import FaImage from "../image/FaImage";
import Image from "next/image";
import { FaFacebookF, FaTwitter, FaInstagram, FaYoutube } from "react-icons/fa";
import { useSelector } from "react-redux";

export default function Footer() {
  const setting = useSelector((state) => state.setting.data);

  return (
    <footer className="footer-section">
      <div className="container mx-auto px-4 md:px-8">
        {/* Logo */}
        <div className="text-center md:text-start">
          <Link href="/" className="mb-4 md:mb-6 inline-block">
          <FaImage
            src={
              setting?.logo_dark_url ??
              "/images/header-footer/main_logo_light.avif"
            }
            alt={"Mail Logo"}
            width={165}
            height={48}
            classes={"w-full mx-auto md:mx-[unset]"}
            className="footer-logo"
          />
          {/* <FaImage
                src={
                 setting?.logo_dark_url ??
                  "/images/header-footer/main_logo_light.avif"
                }
                alt={"Mail Logo"}
                width={200}
                height={50}
                classes={"w-full hidden [.dark_&]:inline-block"} 
                className="footer-logo"
              /> */}
          </Link>
        </div>
        <div className="grid grid-cols-12 gap-4 sm:gap-6 md:gap-8 border-b border-b-primary-2-border pb-6">
          <div className="col-span-12 md:col-span-8"> 
            <ul className="footer-links">
              {[
                { label: "আমরা কারা", href: "/about-us" },
                { label: "নোটিশ বোর্ড", href: "/notice-board" },
                { label: "সাকসেস স্টোরি", href: "/success-stories" },
                { label: "ব্লগ", href: "/blogs" },
                // { label: "শিক্ষক লগইন", href: "/teacher/login" },
                { label: "এফ এ কিউ", href: "/faqs" },
                { label: "যোগাযোগ", href: "/contact" },
              ].map((link, index) => (
                <li key={index}>
                  <Link href={link.href} className="">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div className="col-span-12 md:col-span-4">
            <div className="social-icons">
              {setting?.facebook && (
                <a
                  href={setting.facebook}
                  className="social-icon"
                  target="_blank"
                >
                  <span className="sr-only">Facebook</span>
                  <FaFacebookF />
                </a>
              )}
              {setting?.twitter && (
                <a
                  href={setting.twitter}
                  className="social-icon"
                  target="_blank"
                >
                  <span className="sr-only">Twitter</span>
                  <FaTwitter />
                </a>
              )}
              {setting?.instagram && (
                <a
                  href={setting.instagram}
                  className="social-icon"
                  target="_blank"
                >
                  <span className="sr-only">Instagram</span>
                  <FaInstagram />
                </a>
              )}
              {setting?.youtube && (
                <a
                  href={setting.youtube}
                  className="social-icon"
                  target="_blank"
                >
                  <span className="sr-only">YouTube</span>
                  <FaYoutube />
                </a>
              )}
            </div>
          </div>
        </div>

        <div className="ssl-image">
          <Image 
            src={'/images/home/sslcommerz-banner 1.png'} 
            alt="icon" 
            className="h-auto"
            fill
          />
        </div>
      </div>
      <div className="footer-copyright">
        <div className="container">
          <div className="flex flex-col lg:flex-row sm:justify-between justify-center items-center gap-4">
            <div className="copyright-links">
              <Link href="/terms-conditions" className="links-item">
                টার্মস এন্ড কনডিশন
              </Link>
              <Link href="/privacy-policy" className="links-item">
                প্রাইভেসি পলিসি
              </Link>
              <Link href="/refund-policy" className="links-item">
                রিফান্ড পলিসি
              </Link>
              
            </div>
            <p className="copyright-text">
              কপিরাইট &copy; {new Date().getFullYear()} ফোকাস Developed and Maintenance by <Link
                  href="https://innovait.com.bd"
                  target="_blank"
                  className="text-secondary-text"
                >
                 “INNOVA IT”
                </Link>
            </p>
          </div>
        </div>
      </div>
    </footer>

    
  );
}
